// @flow
import React from 'react';
import { type MultipleAccountsUser } from 'app/common/lib/MultipleAccountsUtils';
import { Avatar, Box, Text } from 'gestalt';

type Props = {
  account: MultipleAccountsUser,
  large?: boolean,
  viewerId?: string,
};

export const AccountSwitcherListItem = (props: Props) => {
  if (props.viewerId === props.account.id) {
    // We don't return a list item for the current viewer, as this is a special heading item
    return null;
  } else {
    const hasCustomImage =
      props.account.imageMediumUrl &&
      !props.account.imageMediumUrl.includes('static/images/user/default');
    return (
      <Box alignItems="center" direction="row" display="flex" height="100%" width="100%">
        <Box paddingX={1}>
          <Avatar
            name={props.account.fullName || props.account.username}
            src={hasCustomImage ? props.account.imageMediumUrl : ''}
            size={props.large ? 'lg' : 'md'}
          />
        </Box>
        <Box marginLeft={3} flex="grow">
          <Text color="darkGray" size="md" truncate weight="bold">
            {props.account.fullName || props.account.username}
          </Text>
          {props.account.email && (
            <Text color="darkGray" size="md" truncate>
              {props.account.email}
            </Text>
          )}
        </Box>
      </Box>
    );
  }
};

export default AccountSwitcherListItem;
